export const GROUPS_FEATURE_ENABLED = String(import.meta.env.VITE_GROUPS_FEATURE_ENABLED || '').toLowerCase() === 'true';
